import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { PrimaryButton, SecondaryButton } from "@loanbossinc/component-library";
import styled from "styled-components";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding-right: 60px;
    color: #666;
  }
`;

export class SimpleInfoModal extends React.Component {
  render() {
    const { title, content, isOpen, onClose, onAccept, disableAccept, acceptLabel = "OK" } = this.props;

    return (
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>{title}</DialogTitle>
        <StyledDialogIconButton onClick={onClose}>
          <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
        </StyledDialogIconButton>
        <StyledDialogContent>
          {content}
        </StyledDialogContent>
        <DialogActions>
          {onClose && <SecondaryButton size={"sm"} onClick={onClose} label="Cancel" style={{ "margin-right": "16px" }} />}
          <PrimaryButton disabled={disableAccept} size={"sm"} onClick={onAccept} label={acceptLabel} />
        </DialogActions>
      </Dialog>
    );
  }
}
